import { useState } from 'react'

export interface CourseListState {
  status: string
  owner: string
  search: string
  sort: string
  direction: 'asc' | 'desc'
}

function initialState(): CourseListState {
  const params = new URLSearchParams(window.location.search)
  return {
    status: params.get('status') ?? 'active',
    owner: params.get('owner') ?? '',
    search: params.get('search') ?? '',
    sort: params.get('sort') ?? 'title',
    direction: params.get('direction') === 'desc' ? 'desc' : 'asc',
  }
}

export function useCourseListState() {
  const [state, setState] = useState(initialState)
  function update(changes: Partial<CourseListState>) {
    const next = { ...state, ...changes }
    window.history.replaceState({}, '', `${window.location.pathname}?${new URLSearchParams(next)}`)
    setState(next)
  }
  function toggleSort(sort: string) {
    const descending = state.sort === sort && state.direction === 'asc'
    update({ sort, direction: descending ? 'desc' : 'asc' })
  }
  return { state, update, toggleSort }
}
